import { render } from "./Menu.vue?vue&type=template&id=5461c928&scoped=true"
import script from "./Menu.js?vue&type=script&lang=js"
export * from "./Menu.js?vue&type=script&lang=js"

import "./Menu.scss?vue&type=style&index=0&id=5461c928&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5461c928"]])

export default __exports__